import { Box, Stack } from "@mui/material";
import { Typography } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { EmptyContent } from "../../common/components/empty-content/EmptyContent";
import { TransportationLogTable } from "./TransportationLogTable";
import { TrackingEventWithId } from "@/common/internalModels";

interface TransportationLogProps {
  trackingEvents: TrackingEventWithId[] | undefined;
  isOcean: boolean;
}

export const TransportationLog = ({ trackingEvents, isOcean }: TransportationLogProps) => {
  const translate = useTranslation();

  if (!trackingEvents || trackingEvents?.length == 0) {
    return (
      <Box display="flex" justifyContent={'center'} data-testid="transportation-logs">
        <EmptyContent title='Transportation log currently unavailable' bodyText='Check again later for updates.' />
      </Box>
    );
  }

  return (
    <Stack spacing={3} padding={1} data-testid="transportation-logs">
      <Typography variant="h2">{translate('Transportation Log')}</Typography>
      <Box>
        <TransportationLogTable rows={trackingEvents} isOcean={isOcean} />
      </Box>
    </Stack>
  );
}
